import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';

interface BasicOperatorItemProps {
  text: string;
}

export function BasicOperatorItem({ text }: BasicOperatorItemProps) {
  return (
    <View padding={1}>
      <Text size="body1">{text}</Text>
    </View>
  );
}
